import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, signal, ViewEncapsulation } from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { SelectModule } from 'primeng/select';
import { RouterOutlet } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Observable } from 'rxjs';
import { LoadingSpinnerService } from './loading-spinner.service';



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,AsyncPipe,CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  loading$: Observable<boolean>;

  constructor(private loadingSpinnerService: LoadingSpinnerService) {
    this.loading$ = this.loadingSpinnerService.loading$;
  }
}
